/* @flow */

export default class ConfirmCompanyUBOsRequest {
  companyId: number;

  constructor(companyId: number) {
    this.companyId = companyId;
  }
}
